import React from "react";
import { Loader2, PackageOpen, AlertTriangle } from "lucide-react";

export function LoadingState({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-stone-500" data-testid="loading-state">
      <Loader2 className="animate-spin text-primary mb-3" size={28} />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="empty-state">
      <div className="h-14 w-14 rounded-full bg-muted grid place-items-center mb-4">
        <PackageOpen className="text-stone-400" size={26} />
      </div>
      <h3 className="font-serif text-xl font-semibold text-stone-800">{title}</h3>
      {message && <p className="mt-1 text-sm text-stone-500 max-w-sm">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong. Please try again." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="error-state">
      <div className="h-14 w-14 rounded-full bg-red-50 grid place-items-center mb-4">
        <AlertTriangle className="text-red-500" size={26} />
      </div>
      <p className="text-sm text-stone-600 max-w-sm">{message}</p>
    </div>
  );
}
